
<mat-tab-group  mat-align-tabs="center" animationDuration="0ms">
  <mat-tab [label]="'label.common.mandatory-informations' | translate">
      <ng-template matTabContent>
          <neq-samples-mandatory-properties (saveClick)="save()" [canSave]="isGlobalFormNotPristineAndValid()"
            [mandatoryForm]="mandatoryForm" [notesForm]="notesForm" [sample]="sample" [(isThereLinkedBu)]="isThereLinkedBu"
            [(selectedSupplier)]="selectedSupplier" [(selectedReference)]="selectedReference" [(selectedEntity)]="selectedEntity"
            [(selectedBusinessUnit)]="selectedBusinessUnit" [(businessUnitFromMainEntity)]="businessUnitFromMainEntity"
            [(selectedCustomer)]="selectedCustomer" [(isThereLinkedCustomer)]="isThereLinkedCustomer"
            [(customerFromMainEntity)]="customerFromMainEntity" [(fillFormDone)]="mandatoryFormAlreadyFilled"
          ></neq-samples-mandatory-properties>
      </ng-template>
  </mat-tab>
  <mat-tab [disabled]="mandatoryForm.invalid"
    [label]="'label.common.complementary-informations' | translate"
  >
      <ng-template matTabContent>
        <neq-samples-optional-properties (saveClick)="save()" [canSave]="isGlobalFormNotPristineAndValid()"
          [optionalForm]="optionalForm" [notesForm]="notesForm" [sample]="sample"
          [selectedSupplier]="selectedSupplier" [selectedCustomer]="selectedCustomer"
        ></neq-samples-optional-properties>
      </ng-template>
  </mat-tab>
</mat-tab-group>